<template>
  
  <div id="PDFContainer">

    <form id="pdf-form" style="display:none" method="post" target="_blank" enctype="multipart/form-data" :action="actionurl">
      <input name="return" value="file">
      <input name="format" value="blob">
      <textarea name="body">{{ bodyHTML}}</textarea>
    </form>

    <div id="pdf-dl" class="eindschermen eindschermen--pdf-dl">

      <headerFeedback :step="step" :doel="doel"/>

      <div class="main-content">
        
        <div class="inhoudsopgave">
          <ul>
            <li>Fase/doel</li>
            <li>Geselecteerde methodes</li>
          </ul>
        </div>

        <div class="doeltekst">
          <h3>Fase: {{ fase }}</h3>
          <h3>Doel: {{ doel }}</h3>
          <div v-html="doelData.description"></div>
        </div>

        <div class="methodes-overzicht">
          <MethodeCardPDF v-for="(methode, i) in methodeData" :key="methode.id" :index="i" :methode="methode" :view="view"></MethodeCardPDF>
        </div>

      </div>
    
    </div>

  </div>
</template>



<script>
import headerFeedback from '../components/headerFeedback.vue';
import MethodeCardPDF from '../components/MethodeCardPDF.vue';
import storage from '../mixins/storage';

const ENDPOINT_NAME = 'ppw/v1/endresult';
const axios = require('axios');

export default {
  name: "eindResultaat",

  mixins: [ storage ],

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      storedMethods: [],
      endresultslug: '',
      endResult: [],
      doelData: [],
      methodeData: [],
      firstrow: [],
      waardes: [],
      initiatief: '',
      fase: '',
      doel: '',
      pushers: [],
      step: 'html',
      hiddenTips: [],
      view: 'HTML',
      actionurl: process.env.VUE_APP_MPDF_URL,
      bodyHTML: '',
    };

   },

  components: {
    MethodeCardPDF,
    headerFeedback,
  },

  computed: {
    
  },
  
  methods: {

    getEndResult() {
      this.storedMethods = JSON.parse(localStorage.getItem('comparedItems'));
      // maybe better to use the slug ...
      this.doel = this.getTarget() ? this.getTarget().name : '';
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_NAME + '?doel='+ this.doel +'&methodes=' + this.storedMethods[0].methods);      
      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data;
          if (!results) {
            this.endResult[0] = 'no result';
          } else {
            this.endResult = r.data;
            this.doelData = r.data.doel;
            this.methodeData = r.data.methodes;
          }

          setTimeout(() => this.getPDFFromApi(), 150);
        })
        .catch(error => {
          console.warn(error);
        })
    },

    cleanClass(j) {
      return 'row_'+j.replace(/ \/ /g, '');
    },

    /**
     * POST html to mPDF generator
     */
    getPDFFromApi() {

      const pdfdlEl = document.getElementById("pdf-dl");
      const html = pdfdlEl.outerHTML
      
      this.bodyHTML = html
      this.$nextTick(() => document.getElementById("pdf-form").submit())
    },  
  },

  created() {
  },

  mounted() {
    setTimeout(() => this.getEndResult(), 70);
  }
};

</script>

